import navigation from "@/lang/fr_CA/navigation";
import generics from "@/lang/fr_CA/generics";
import questions from "@/lang/fr_CA/questions";
import a11y from "@/lang/fr_CA/a11y";
import velt from "@/lang/fr_CA/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
